var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.7581L16.5 18.7581C17.6046 18.7581 18.5 17.8626 18.5 16.7581L18.5 2.75806C18.5 1.65349 17.6046 0.758057 16.5 0.758057L2.5 0.758057C1.39543 0.758057 0.5 1.65349 0.5 2.75806L0.5 16.7581C0.5 17.8626 1.39543 18.7581 2.5 18.7581Z",
    fill: "url(#paint0_linear_265_4865)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 17.7581C17.0523 17.7581 17.5 17.3103 17.5 16.7581L17.5 2.75806C17.5 2.20577 17.0523 1.75806 16.5 1.75806L2.5 1.75806C1.94772 1.75806 1.5 2.20577 1.5 2.75806L1.5 16.7581C1.5 17.3103 1.94772 17.7581 2.5 17.7581L16.5 17.7581ZM18.5 16.7581C18.5 17.8626 17.6046 18.7581 16.5 18.7581L2.5 18.7581C1.39543 18.7581 0.5 17.8626 0.5 16.7581L0.5 2.75806C0.5 1.65349 1.39543 0.758057 2.5 0.758057L16.5 0.758057C17.6046 0.758057 18.5 1.65349 18.5 2.75806L18.5 16.7581Z",
    fill: "#3A56A2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_4865",
    x1: 9.5,
    y1: 18.7581,
    x2: 9.5,
    y2: 0.758057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_265_4865",
    x1: 10.1744,
    y1: 2,
    x2: 10.1744,
    y2: 16.2765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94E174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52781F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.6addc2d7.svg";
export { ForwardRef as ReactComponent };